import _ from "underscore";

import React from 'react';
import PropTypes from 'prop-types';

import ClassNames from 'classnames';
import TerminalSearch from './TerminalSearch';

class Sidebar extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      searchText: ""
    };

    this.handleUserInput = this.handleUserInput.bind(this);
  }

  handleUserInput(searchText) {
    this.setState({
      searchText: searchText
    });
  }

  render() {
    var index = 1;
    return (
      <div className={ ClassNames('sidebar', { 'sidebar-disabled': this.props.disabled }) }>
        <h6>Click conditions below to build a rule</h6>
        <TerminalSearch
          searchText={this.state.searchText}
          onUserInput={this.handleUserInput}
        />
        {_.map(this._nodeGroups(), function(nodeNames, groupName) {
          return (
            <GroupTerminal
              key={groupName}
              nodeNames={nodeNames}
              groupName={groupName}
              index={index++}
              onTerminalClick={this.props.onInsertTerminal}
              terminalMetaData={this.props.terminalMetaData}
            />);
        }, this)}
      </div>
    );
  }

  _nodeGroups() {
    const groups = {};

    _.each(this.props.terminalMetaData, ({ access, displayName, groupName }, terminalName) => {
      groups[groupName] = groups[groupName] || [];

      if (this._terminalAccess(access)) {
        if (this.state.searchText === "" || displayName.match(new RegExp(this.state.searchText, "i"))) {
          groups[groupName].push(terminalName);
        }
      }
    });

    return _.omit(groups, _.isEmpty);
  }

  _terminalAccess(access) {
    if (!access) {
      return true;
    } else if (access.values) {
      return _.contains(access.values, this.props.features[access.feature]);
    } else if (access.feature) {
      return this.props.features[access.feature];
    } else if (access.sharedTerminal) {
      return false;
    }
  }
}

Sidebar.propTypes = {
  features: PropTypes.object.isRequired,
  onInsertTerminal: PropTypes.func.isRequired,
  terminalMetaData: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

class GroupTerminal extends React.Component {
  render() {
    return (
      <div>
        <h4>{this.props.groupName}</h4>
        <ul>
          {_.map(this.props.nodeNames, function(nodeName) {
            return (
              <li
                key={this.props.groupName + ':' + nodeName}
                onClick={this.props.onTerminalClick.bind(null, nodeName)}
              >
                {this.props.terminalMetaData[nodeName].displayName}
              </li>);
          }, this)}
        </ul>
      </div>
    );
  }
}

GroupTerminal.propTypes = {
  terminalMetaData: PropTypes.object.isRequired,
  onTerminalClick: PropTypes.func.isRequired
};

export default Sidebar;
